import { Statistic } from '@/types';

/**
 * Sum the per-severity Open-risk statistics into a single total, used as the
 * `totalDatabaseCount` fallback for the vulnerabilities count surfaces.
 *
 * Returns `undefined` (NOT `0`) when there are no statistics to sum. This is
 * load-bearing: `useMy` defaults its `data` to `[]` (not `undefined`) when the
 * query is disabled — e.g. in the asset drawer, where the statistics query is
 * gated behind `enabled: !hideTitle`. A bare `!riskStatistics` guard never fires
 * on that empty array, so `[].reduce(…, 0)` would produce a real `0` that then
 * shadows `displayData.length` through the `filteredCount ?? totalDatabaseCount ??
 * displayData.length` chain (`??` only falls through on null/undefined, never on
 * `0`) — surfacing as "0 vulnerabilities" / "N of 0 selected" over a populated
 * drawer list (ENG-4524). Treating the empty array as "no data → undefined" lets
 * the chain fall through to the loaded-row count.
 */
export function computeTotalDatabaseCount(
  riskStatistics: Statistic[] | undefined
): number | undefined {
  if (!riskStatistics || riskStatistics.length === 0) return undefined;
  return riskStatistics.reduce((sum, item) => sum + (item.data?.count || 0), 0);
}
